// frontend/src/components/ScreenerUploadForm.jsx
import React, { useState } from "react";
import { useAuth } from "../AuthProvider";

const ScreenerUploadForm = () => {
  const { token } = useAuth();
  const [files, setFiles] = useState([]);
  const [snapshotDate, setSnapshotDate] = useState(""); // optional: YYYY-MM-DD
  const [message, setMessage] = useState("");
  const [result, setResult] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  const handleFileChange = (e) => {
    const selected = Array.from(e.target.files || []);
    setFiles(selected);
    setMessage("");
    setResult(null);
  };

  const handleUpload = async () => {
    if (!files.length) {
      setMessage("Pilih minimal 1 file .xlsx terlebih dahulu.");
      return;
    }

    const formData = new FormData();
    files.forEach((f) => formData.append("files", f));

    setIsUploading(true);
    setMessage("");
    setResult(null);

    try {
      const headers = {};
      if (token) {
        headers["Authorization"] = `Bearer ${token}`;
      }

      // query param snapshot_date kalau user isi
      const queryParam = snapshotDate
        ? `?snapshot_date=${encodeURIComponent(snapshotDate)}`
        : "";

      const res = await fetch(`/api/upload-screener${queryParam}`, {
        method: "POST",
        headers,
        body: formData, // ⛔ jangan set Content-Type manual
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.detail || "Upload screener gagal");
      }

      setResult(data);
      setMessage("Upload & proses Stock Screener berhasil ✅");
    } catch (err) {
      setMessage(`Error: ${err.message}`);
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className="text-sm text-gray-100">
      <div className="space-y-3">
        {/* Tanggal Screener (opsional) */}
        <div>
          <label className="block text-xs font-medium mb-1">
            Snapshot Date (opsional)
          </label>
          <input
            type="date"
            value={snapshotDate}
            onChange={(e) => setSnapshotDate(e.target.value)}
            className="w-full bg-gray-800 border border-gray-600 rounded px-2 py-1 text-xs text-gray-100"
          />
          <p className="mt-1 text-[11px] text-gray-400">
            Jika dikosongkan, sistem akan memakai trade_date terbaru dari
            <span className="font-semibold"> daily_stocks</span>.
          </p>
        </div>

        {/* Input File */}
        <div>
          <label className="block text-xs font-medium mb-1">
            Pilih file IDX Stock Screener (.xlsx)
          </label>
          <input
            type="file"
            accept=".xlsx"
            multiple
            onChange={handleFileChange}
            className="block w-full text-xs text-gray-200
                       file:mr-3 file:py-1.5 file:px-3
                       file:rounded-md file:border-0
                       file:text-xs file:font-medium
                       file:bg-indigo-600 file:text-white
                       hover:file:bg-indigo-500"
          />
          <p className="mt-1 text-[11px] text-gray-400">
            Bisa upload beberapa file sekaligus (misalnya beberapa hari).
          </p>
        </div>

        {/* Tombol Upload */}
        <button
          onClick={handleUpload}
          disabled={isUploading || !files.length}
          className={`w-full py-2 px-3 rounded-lg text-sm font-semibold
            ${
              isUploading || !files.length
                ? "bg-gray-600 text-gray-300 cursor-not-allowed"
                : "bg-indigo-600 hover:bg-indigo-500 text-white"
            }`}
        >
          {isUploading ? "Mengupload & memproses..." : "Upload Screener"}
        </button>

        {/* Status */}
        {message && (
          <p className="mt-1 text-xs whitespace-pre-line">
            {message}
          </p>
        )}

        {/* Hasil */}
        {result && (
          <div className="mt-2 border-t border-gray-700 pt-2 text-xs">
            <h3 className="font-semibold mb-1">Ringkasan hasil:</h3>
            <p>Snapshot date: {result.snapshot_date}</p>
            <p>Total rows (gabungan file): {result.total_rows}</p>
            <p>Rows inserted: {result.rows_inserted}</p>
            <p className="mt-1">
              Files:{" "}
              {(result.files_processed || []).join(", ")}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ScreenerUploadForm;
